import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";
import "air-datepicker/air-datepicker.css";
import courseTestData from "./course-finder-form-data.js";

window.Moonbase = window.Moonbase || {};
window.Moonbase.AirDatepicker = AirDatepicker;

class CourseFinderForm extends HTMLElement {
  constructor() {
    super();
    // Variables
    this.wptLocationInput = this.querySelector("#location");
    this.courseErrorMessage = this.querySelector(".js-course-error-message");
    this.courseListContainer = this.querySelector(".course-list");
    this.wptSpacesInput = this.querySelector("#spaces");
    this.qtyMinusButton = this.querySelector(".js-attendees-minus");
    this.qtyPlusButton = this.querySelector(".js-attendees-plus");
    this.wptGeoLocationInput = this.querySelector(".js-my-location-button");
    this.wptRangeRangeInput = this.querySelector("#wpt-date-range");
    this.wptCalendarInput = this.querySelector("#wpt-date-range-container");
    this.wptCalendarContainer = this.querySelector(".wpt-calendar-container");
    this.datePickerClearButton = this.querySelector("[data-picker-clear]");
    this.datePickerCloseButton = this.querySelector("[data-picker-close]");
    this.submitButton = this.querySelector("button[type='submit']");
    this.showCourseModalButton = this.querySelector(".js-show-course-modal");
    this.formFieldContainers = this.querySelectorAll(".course-form__field");
    this.closeCourseModalButton = this.querySelector(
      ".js-close-course-search-form"
    );
    this.courseTypeDropdown = this.querySelector(
      ".nice-select.wpt-variant-type-select"
    );
    this.formFieldContainers.forEach((container) => {
      container.addEventListener("mouseenter", () => {
        container.classList.add("active");
      });
      container.addEventListener("mouseleave", () => {
        container.classList.remove("active");
      });
    });
    this.datePicker = null;
    this.returnedCourseData = null;
    this.cardTemplate = document.getElementById("course-product");
    if (!this.cardTemplate) {
      console.error("Template with id 'course-product' not found.");
      return;
    }
    if (!this.courseTypeDropdown) {
      const intervalId = setInterval(() => {
        const dropdown = this.querySelector(
          ".nice-select.wpt-variant-type-select"
        );
        if (dropdown) {
          const currentSpan = dropdown.querySelector("span.current");
          let lastValue = currentSpan?.innerText;
          const observer = new MutationObserver(() => {
            if (currentSpan.innerText !== lastValue) {
              if (currentSpan.innerText == "On-site") {
                console.log("On-site selected");
              } else {
                this.filterCourses(currentSpan.innerText);
              }
            }
          });
          if (currentSpan) {
            observer.observe(currentSpan, {
              childList: true,
              subtree: true,
              characterData: true,
            });
          }
          clearInterval(intervalId);
        }
      }, 1000);
    }

    // Functions

    // Bind the context of the methods to the class instance
    this.init();

    this.wptLocationInput?.addEventListener(
      "focus",
      this.openGeoLocation.bind(this)
    );

    // Quantity minus button
    this.qtyMinusButton?.addEventListener("click", (event) => {
      event.preventDefault();
      const currentValue = parseInt(this.wptSpacesInput.value, 10);
      if (currentValue > 1 && currentValue <= 4) {
        this.wptSpacesInput.value = currentValue - 1;
        this.courseErrorMessage.classList.add("hidden");
      } else {
        this.renderErrorMessage(
          window.Moonbase.locales.products.product.course.error.limit
        );
      }
    });

    // Quantity plus button
    this.qtyPlusButton?.addEventListener("click", (event) => {
      event.preventDefault();
      const currentValue = parseInt(this.wptSpacesInput.value, 10);
      if (currentValue < 4) {
        this.wptSpacesInput.value = currentValue + 1;
        this.courseErrorMessage.classList.add("hidden");
      } else {
        this.renderErrorMessage(
          window.Moonbase.locales.products.product.course.error.limit
        );
      }
    });

    // Ensure the date picker clears when the clear button is clicked
    this.datePickerClearButton?.addEventListener(
      "click",
      this.clearCalendar.bind(this)
    );

    // Ensure the date picker closes when the close button is clicked
    this.datePickerCloseButton?.addEventListener(
      "click",
      this.closeCalendar.bind(this)
    );

    // Ensure the date picker closes when the close button is clicked
    this.wptGeoLocationInput?.addEventListener(
      "click",
      this.getGeoLocation.bind(this)
    );

    this.closeCourseModalButton?.addEventListener(
      "click",
      this.closeCourseModal.bind(this)
    );

    // Ensure the form submits when the submit button is clicked
    this.submitButton?.addEventListener("click", this.onSubmit.bind(this));

    // Ensure the calendar opens when the show course modal button is clicked
    this.showCourseModalButton?.addEventListener(
      "click",
      this.onShowCourseModal.bind(this)
    );

    // Ensure the calendar opens when the range input is focused
    // this.wptRangeRangeInput?.addEventListener(
    //   "click",
    //   this.onShowCourseModal.bind(this)
    // );

    // Ensure the calendar opens when the range input is focused
    this.wptRangeRangeInput?.addEventListener("focus", () => {
      this.calendarFocus();
    });

    // Ensure the date picker input updates the range input value
    this.datePickerCloseButton?.addEventListener("click", () => {
      this.wptRangeRangeInput.value = this.wptCalendarInput.value;
    });
  }

  // Initialize the date picker
  init() {
    this.datePicker = new window.Moonbase.AirDatepicker(this.wptCalendarInput, {
      inline: true,
      locale: localeEn,
      dateFormat: "MMMM d", // e.g., July 5
      multipleDatesSeparator: " - ",
      range: true,
      minDate: new Date(),
      selectedDates: [new Date()],
    });
    // this.datePicker?.show();
  }

  filterCourses(courseType) {
    const filteredCourses = Array.isArray(this.returnedCourseData)
      ? this.returnedCourseData.filter(
          (course) => course.courseType === courseType
        )
      : [];
    const courseList = this.courseListContainer;
    // Remove all children from container except buttons
    Array.from(courseList.children).forEach((child) => {
      if (child.tagName.toLowerCase() !== "button") {
        courseList.removeChild(child);
      }
    });
    filteredCourses.forEach((course) => {
      this.injectCard(course, this.cardTemplate, this.courseListContainer);
    });
    if (courseType && courseType.toLowerCase().includes("online")) {
      const mapButton = this.querySelector("button[js-open-map-modal]");
      if (mapButton) {
        mapButton.classList.add("!hidden");
      }
    } else {
      const mapButton = this.querySelector("button[js-open-map-modal]");
      if (mapButton) {
        mapButton.classList.remove("!hidden");
      }
    }
  }

  openGeoLocation() {
    if (!this.wptGeoLocationInput) return;
    this.wptGeoLocationInput.classList.remove("hidden");
  }

  // Ensure the date picker input updates the range input value
  connectedCallback() {
    if (this.wptCalendarInput && this.wptRangeRangeInput) {
      this.wptCalendarInput.addEventListener("change", (event) => {
        this.wptRangeRangeInput.value = event.target.value;
      });
    }
  }

  async getGeoLocation() {
    const location = await fetch(
      window.Shopify.routes.root + "browsing_context_suggestions.json"
    );
    const data = await location.json();
    this.wptLocationInput.value = data.detected_values.country_name || "";
  }

  closeCourseModal() {
    document.body.classList.remove("course-modal-open");
    const courseModal = document.querySelector(".course-modal");
    if (courseModal) {
      courseModal.remove();
    }
  }

  // Clone the component and insert it into the body
  onShowCourseModal() {
    const clone = this.cloneNode(true);
    clone.setAttribute("data-cloned", "true");
    // Remove the date picker input from the cloned component
    const calendarContainer = clone.querySelector(".wpt-calendar-container");
    if (calendarContainer) {
      const keep = calendarContainer.querySelector("#wpt-date-range-container");
      Array.from(calendarContainer.children).forEach((child) => {
        if (child !== keep) {
          calendarContainer.removeChild(child);
        }
      });
    }

    const div = document.createElement("div");
    div.classList.add("course-modal");
    const niceSelect = clone.querySelectorAll(".nice-select.form-select");
    if (niceSelect.length) {
      niceSelect.forEach((select) => {
        select.remove();
      });
    }

    div.innerHTML = clone.outerHTML;
    const niceSelects = div.querySelectorAll(".form-select");
    if (niceSelects.length) {
      niceSelects.forEach((select) => {
        new window.Moonbase.NiceSelect(select, { searchable: false });
      });
    }

    const template = this.cardTemplate;
    if (!template) {
      console.error("Template with id 'course-product' not found.");
      return;
    }

    const courseList = div.querySelector(".course-list");
    // Remove all children from container except buttons
    Array.from(courseList.children).forEach((child) => {
      if (child.tagName.toLowerCase() !== "button") {
        courseList.removeChild(child);
      }
    });

    // Use this.returnedCourseData to inject cards into the modal
    if (Array.isArray(this.returnedCourseData)) {
      console.log("modal data", this.returnedCourseData);
      this.returnedCourseData.forEach((card) => {
        this.injectCard(card, template, courseList);
      });
    }
    document.body.insertBefore(div, document.body.lastElementChild);
    document.body.classList.add("course-modal-open");
  }

  // Inject a course card into the course list
  injectCard(card, template, container) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = template.innerHTML;
    const cardElement = tempDiv.firstElementChild;
    if (card.courseType) {
      const handleized = card.courseType
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
      cardElement.setAttribute("data-type", `${handleized}`);
    }
    const formatDateTime = (isoString) => {
      if (!isoString) return "";
      const date = new Date(isoString);
      // Format as MM/DD/YYYY HH:mm
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      const hh = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      return `${mm}/${dd}/${yyyy} ${hh}:${min}`;
    };
    const selectors = {
      courseType: {
        selector: ".js-course-card__type",
        text: card.courseType,
      },
      variantId: {
        selector: "[name='id']",
        value: card.variants && card.variants[0] ? card.variants[0].id : "",
      },
      lineItemPropertyVenue: {
        selector: "#venue",
        value: card.location ? card.location.address : card.location.name,
      },
      lineItemPropertyTimeslot: {
        selector: "#timeslot",
        value: card.startTime
          ? formatDateTime(card.startTime)
          : "No time available",
      },
      name: {
        selector: ".js-course-card__name",
        text: card.location ? card.location.name : "Unknown Location",
      },
      distanceFrom: {
        selector: ".js-course-card__distance_from",
        text: card.location
          ? `${card.location.distance.toFixed(1)} mi`
          : "Distance not available",
      },
      time: {
        selector: ".js-course-card__time",
        text:
          card.startTime && card.endTime
            ? `${card.startTime.split("T")[1].slice(0, 5)} - ${card.endTime
                .split("T")[1]
                .slice(0, 5)}`
            : card.startTime
            ? card.startTime.split("T")[1].slice(0, 5)
            : "",
      },
      address: {
        selector: ".js-course-card__address",
        text: card.location ? card.location.address : "No address available",
      },
      date: {
        selector: ".js-course-card__date",
        text: card.startTime
          ? new Date(card.startTime).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
          : "No date available",
      },
      price: {
        selector: ".js-course-card__price",
        text: card.unitPrice
          ? `£${parseFloat(card.unitPrice).toFixed(
              2
            )} <span class="text-sm text-contrast-five">/ place</span>`
          : "Price not available",
      },
      spacesLeftText: {
        selector: ".js-course-card__spaces-left-text",
        text: `${card.availablePlaces}/${card.totalPlaces}`,
      },
      bookNow: {
        selector: ".js-course-card__book-now",
        text: "Book Now",
        href: `#course-${card.scheduleId}`,
      },
    };

    Object.entries(selectors).forEach(
      ([key, { selector, text, value, href }]) => {
        const element = cardElement.querySelector(selector);
        if (element) {
          const content = typeof value !== "undefined" ? value : text;
          if (
            content === "" ||
            content === null ||
            typeof content === "undefined"
          ) {
            element.style.display = "none";
            return;
          }
          if (key === "bookNow" && href) {
            element.setAttribute("href", href);
            element.innerHTML = text;
          } else if (
            element.tagName === "INPUT" ||
            element.tagName === "SELECT" ||
            element.tagName === "TEXTAREA"
          ) {
            element.value = value;
          } else if (typeof text !== "undefined") {
            element.innerHTML = text;
          }
        } else {
          console.warn(`Selector ${selector} not found in card template.`);
        }
      }
    );

    const spacesLeftCircle = cardElement.querySelector(
      ".js-course-card__spaces-left-circle"
    );
    if (spacesLeftCircle) {
      spacesLeftCircle.classList.remove("low-stock", "stocked");
      if (card.availablePlaces > 1 && card.availablePlaces <= 5) {
        spacesLeftCircle.classList.add("low-stock");
      } else if (card.availablePlaces > 5) {
        spacesLeftCircle.classList.add("stocked");
      }
    }
    container.append(cardElement);
  }

  // Show the calendar with a transition effect
  calendarFocus() {
    const container = this.wptCalendarContainer;
    if (container) {
      container.style.transition = "height 0.3s ease";
      // container.style.overflow = "hidden";
      container.style.display = "block";
      const targetHeight = container.scrollHeight + "px";
      container.style.height = "0px";
      // Force reflow to apply the height transition
      void container.offsetWidth;
      container.style.height = targetHeight;
      // Remove the height after transition to allow for dynamic content
      container.addEventListener("transitionend", function handler() {
        container.style.height = "";
        container.removeEventListener("transitionend", handler);
      });
    }
  }

  // Clear the date picker input and hide the calendar
  clearCalendar() {
    this.datePicker.clear();
  }

  // Close the calendar with a transition effect
  closeCalendar() {
    const container = this.wptCalendarContainer;
    if (container) {
      container.style.transition = "height 0.3s ease";
      // container.style.overflow = "hidden";
      const startHeight = container.scrollHeight + "px";
      container.style.height = startHeight;
      // Force reflow to apply the height transition
      void container.offsetWidth;
      container.style.height = "0px";
      container.addEventListener("transitionend", function handler() {
        container.style.display = "none";
        container.style.height = "";
        container.removeEventListener("transitionend", handler);
      });
    }
    this.datePicker.hide();
  }

  renderCards(data) {
    const locations = data.locations || [];
    const schedules = data.schedules || [];

    // Check if the card template and course list container exist
    if (!this.cardTemplate) {
      console.error("Template with id 'course-product' not found.");
      return;
    }
    if (!this.courseListContainer) {
      console.error("Container with class 'course-list' not found.");
      return;
    }

    // Ensure we have schedules and locations to render and map them to cards
    if (!this.returnedCourseData || this.returnedCourseData.length === 0) {
      const cards = schedules.map((schedule) => {
        const location = locations.find(
          (loc) => loc.locationId === schedule.locationId
        );
        return {
          courseId: schedule.courseId,
          scheduleId: schedule.scheduleId,
          location: location
            ? {
                locationId: location.locationId,
                name: location.name,
                address: location.address,
                latitude: location.latitude,
                longitude: location.longitude,
                distance: location.distance,
              }
            : null,
          startTime: schedule.startTime,
          endTime: schedule.endTime,
          availablePlaces: schedule.availablePlaces,
          totalPlaces: schedule.totalPlaces,
          unitPrice: schedule.unitPrice,
        };
      });
      // For each instance in the cards const, loop through and query /search/suggest.json?q=courseId and console log if the data is returned correctly.
      cards.forEach(async (card, idx) => {
        try {
          const response = await fetch(
            `/search/suggest.json?q=${card.courseId}&resources[type]=product&resources[options][fields]=title,variants.sku`
          );
          if (response.ok) {
            const data = await response.json();
            if (data.resources?.results?.products.length > 0) {
              const product = data.resources.results.products[0];
              // Merge all product data into the card
              Object.assign(card, product, product.variants?.[0]);
              // Optionally, keep original card fields if needed
              // cards[idx] = { ...card, ...product, ...product.variants?.[0] };
            }
          } else {
            console.warn(
              `Failed to fetch for CourseId ${card.courseId}:`,
              response.status
            );
          }
        } catch (error) {
          console.error(`Error fetching for CourseId ${card.courseId}:`, error);
        }
      });

      return (this.returnedCourseData = cards);
    }

    const cards = this.returnedCourseData;

    console.log("Pre", cards);
    cards.sort((a, b) => {
      const aOnline =
        a.courseType && a.courseType.toLowerCase().includes("online");
      const bOnline =
        b.courseType && b.courseType.toLowerCase().includes("online");
      if (aOnline && !bOnline) return 1;
      if (!aOnline && bOnline) return -1;
      return 0;
    });

    // Remove all children from container except buttons
    Array.from(this.courseListContainer.children).forEach((child) => {
      if (child.tagName.toLowerCase() !== "button") {
        this.courseListContainer.removeChild(child);
      }
    });

    // Limit the number of cards rendered to 3
    cards.slice(0, 3).forEach((card) => {
      this.injectCard(card, this.cardTemplate, this.courseListContainer);
    });

    // Show the course filters and list
    this.querySelector(".course-filters")?.classList.remove("!hidden");
    this.querySelector(".course-list")?.classList.remove("!hidden");
    this.querySelector(".js-show-course-modal")?.classList.remove("!hidden");

    console.log("locations", cards);
    // Initialize Google Map with location pins
    const locationPins = cards.map((loc) => ({
      lat: loc.location.latitude,
      lng: loc.location.longitude,
      title: loc.location.name,
      address: loc.location.address,
      places: loc.availablePlaces,
      price: loc.unitPrice,
    }));

    this.populateMap(locationPins);
  }

  renderErrorMessage(message) {
    this.courseErrorMessage.querySelector("span").innerHTML = message;
    this.courseErrorMessage.classList.remove("hidden");
  }

  populateMap(locationPins) {
    /* global google */
    // Initialize Google Map with location pins
    const mapDiv = document.getElementById("google_map");
    if (!mapDiv) return;
    const map = new google.maps.Map(mapDiv, {
      zoom: 6,
      center: { lat: locationPins[0].lat, lng: locationPins[0].lng },
      mapId: "YOUR_MAP_ID_HERE", // Replace with your valid Map ID
    });

    // A marker with a custom inline SVG.
    const parser = new DOMParser();
    const pinSvgString =
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" fill="none" viewBox="0 0 40 41"><foreignObject width="97.5" height="89.412" x="-29.142" y="-10.334"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#a);height:100%;width:100%"/></foreignObject><ellipse cx="19.608" cy="34.372" fill="#474445" fill-opacity=".2" data-figma-bg-blur-radius="40" rx="8.75" ry="4.706"/><path fill="#007a4e" fill-rule="evenodd" stroke="#015033" stroke-linejoin="round" stroke-width="1.5" d="m18.886 34.139.111.063.044.024c.35.192.783.19 1.133.001l.045-.025a13 13 0 0 0 .511-.303c.34-.21.821-.519 1.395-.924a30.7 30.7 0 0 0 4.207-3.58c3.05-3.122 6.217-7.813 6.217-13.846 0-7.148-5.794-12.942-12.941-12.942S6.667 8.401 6.667 15.55c0 6.033 3.167 10.724 6.217 13.846a30.7 30.7 0 0 0 4.207 3.58c.574.405 1.054.714 1.395.924q.256.157.4.24Zm.722-13.885a4.706 4.706 0 1 0 0-9.411 4.706 4.706 0 0 0 0 9.412Z" clip-rule="evenodd"/><defs><clipPath id="a" transform="translate(29.142 10.334)"><ellipse cx="19.608" cy="34.372" rx="8.75" ry="4.706"/></clipPath></defs></svg>';
    const pinSvg = parser.parseFromString(
      pinSvgString,
      "image/svg+xml"
    ).documentElement;

    locationPins.forEach((loc) => {
      // Create the info window content
      const infoWindowContent = document.createElement("div");
      infoWindowContent.classList.add("pt-5");
      infoWindowContent.innerHTML = `
        <h3>${loc.title}</h3>
        <p><span class="font-semibold">Address:</span> ${loc.address}</p>
        <p><span class="font-semibold">Places:</span> ${loc.places}</p>
        <p><span class="font-semibold">Price:</span> £${parseFloat(
          loc.price
        ).toFixed(2)}</p>
      `;

      // Create the info window
      const infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent,
      });

      // Create the advanced marker
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: loc.lat, lng: loc.lng },
        map: map,
        content: pinSvg.cloneNode(true),
        title: loc.title,
      });

      // Add click listener to show info window
      marker.addListener("click", () => {
        infoWindow.open({
          anchor: marker,
          map,
        });
      });
    });
  }

  // Handle form submission
  onSubmit() {
    const formElements = this.querySelectorAll("input, select, textarea");
    const values = {};
    formElements.forEach((el) => {
      if (el.name) {
        if (el.id === "wpt-date-range") {
          if (el.value.includes(",")) {
            const [from, to] = el.value.split(",").map((v) => v.trim());
            values.fromDate = from;
            values.toDate = to;
          } else {
            values.fromDate = el.value;
          }
        } else if (el.type === "checkbox") {
          values[el.name] = el.checked;
        } else if (el.type === "radio") {
          if (el.checked) {
            values[el.name] = el.value;
          }
        } else {
          values[el.name] = el.value;
        }
      }
    });
    // Remove unnecessary fields
    delete values["wpt-date-range-container"];
    delete values["course-type"];
    if (values.courseIds && typeof values.courseIds === "string") {
      values.courseIds = [values.courseIds];
    }

    // Check to see if we are in development mode / preview mode
    // If so, use the test data from courseTestData
    // Otherwise, use the production endpoint
    const isDev = true;
    const devEndpoint = null;
    const prodEndpoint = "https://example.com/prod-endpoint";

    // Fake fetch for dev
    function fakeFetch(payload) {
      const exampleResponse = courseTestData;
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            json: () => Promise.resolve(exampleResponse),
          });
        }, 500);
      });
    }

    const payload = values;
    const endpoint = isDev ? devEndpoint : prodEndpoint;
    if (isDev) {
      fakeFetch(payload)
        .then((response) => response.json())
        .then((data) => {
          if (data.meta.error) {
            this.renderErrorMessage(data.meta.error);
          } else {
            this.renderCards(data);
          }
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
          this.renderErrorMessage(error);
        });
    } else {
      // TODO: T3/T4 Work - Once the production endpoint is ready, replace the fetch with the actual endpoint
      fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.meta.error) {
            this.renderErrorMessage(data.meta.error);
          } else {
            this.renderCards(data);
          }
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
          this.renderErrorMessage(error);
        });
    }
  }
}

customElements.define("course-finder-form", CourseFinderForm);
